import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UsersState } from './users.type';

export const USERS_REDUCER_NAME = 'users';

const initialState: UsersState = {
    users: [],
};

export const usersSlice = createSlice({
    name: USERS_REDUCER_NAME,
    initialState,
    reducers: {
        setUsers: (state, action: PayloadAction<UsersState['users']>) => {
            state.users = action.payload;
        },
    },
});

export const { setUsers } = usersSlice.actions;

export const usersReducer = usersSlice.reducer;
